module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '2czj0jid',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
